module.exports = __webpack_public_path__ + "static/media/fe_lockeroom.292a60fd.png";